import { useMemo } from "react";

import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Tooltip, Typography } from "@mui/material";

import { bankBgColor } from "@/constants/config";
import { bankCardSmallImg } from "@/constants/image-map";
import { BANK_NAME_MAP, PROGRAM_IMG, PROGRAM_NAME_MAP } from "@/constants/programs";
import useThemeData from "@/hooks/useThemeData";
import { FlightItem } from "@/typings";

import usePlatform from "../usePlatform";

interface BanksProps {
  data: FlightItem;
}
const Banks = (props: BanksProps) => {
  const { data } = props;
  const theme = useThemeData();

  const { isPc } = usePlatform();
  const options = useMemo(() => {
    return (data.transfer_options || []).map((ele) => ({
      img: bankCardSmallImg[ele.program],
      title: BANK_NAME_MAP[ele.program],
      bonus: ele.bonus,
    }));
  }, [data]);

  const toolTipText = useMemo(
    () =>
      options
        .slice(2)
        .map((ele) => ele.title)
        .join("\n"),
    [options]
  );

  const SHOW_IMAGE_NUMBER = options.length == 6 ? 6 : options.length - 1;

  return (
    <div
      className={
        "flex !px-[0px] items-center" +
        (isPc ? "h-full justify-center mx-[12px] w-[100px] flex-col items-center" : "")
      }
    >
      {options.length > 0 ? (
        <Box
          className="md:w-full flex flex-wrap rounded-[6px] px-[2px] py-[5px] justify-center items-center"
          sx={{
            maxHeight: "96px",
            maxWidth: "112px",
            backgroundColor: theme.isDarkMode ? bankBgColor : "#EEEEEE",
          }}
        >
          {options.map((ele, i) => {
            return (
              <Tooltip
                key={i}
                arrow
                placement="top"
                enterDelay={200}
                enterTouchDelay={400}
                title={
                  <div>
                    <Typography>
                      <div className="flex items-center">
                        <img src={ele.img} className={`object-contain p-[1px] h-[1.6em] mr-[8px]`} />
                        {ele.title}
                      </div>
                    </Typography>
                    <Typography color={"primary"} sx={{ marginTop: 0 }}>
                      {ele.bonus ? "\n+" + ele.bonus + "% transfer bonus" : null}
                    </Typography>
                  </div>
                }
              >
                <div
                  key={i}
                  className={
                    (i >= 2 ? "relative px-[5px]" : "relative px-[5px]") +
                    "!h-[30px] !w-[30px] text-[0px]" +
                    (ele.bonus ? " animate-pulse" : "")
                  }
                >
                  <img src={ele.img} className={`w-full h-full object-contain p-[1px]`} />
                </div>
              </Tooltip>
            );
          })}

          {/* {options.length > 6 ? (
            <Tooltip
              arrow
              enterDelay={400}
              enterTouchDelay={400}
              title={<div style={{ whiteSpace: "pre-line" }}>{toolTipText}</div>}
            >
              <Typography
                color="textSecondary"
                variant="caption"
                textAlign="center"
                fontSize={11}
                fontWeight="bold"
                className="pt-[3px]"
              >
                +{options.length - SHOW_IMAGE_NUMBER}
              </Typography>
            </Tooltip>
          ) : null} */}
        </Box>
      ) : (
        <div />
      )}

      {options && options.length > 0 ? (
        isPc ? (
          <ArrowDownwardIcon
            className="!text-[12px] my-[3px]"
            sx={{ color: (theme) => theme.palette.text.secondary }}
          />
        ) : (
          <ArrowForwardIcon
            className="!text-[12px]"
            sx={{ color: (theme) => theme.palette.text.secondary }}
          />
        )
      ) : null}

      <Tooltip
        arrow
        enterDelay={400}
        enterTouchDelay={400}
        title={PROGRAM_NAME_MAP.get(data.program_code)}
      >
        <div
          className={"h-[35px] overflow-hidden w-[100px] p-[5px] rounded-[5px]"}
          style={{ backgroundColor: theme.isDarkMode ? bankBgColor : "#EEEEEE" }}
        >
          <img className="object-contain w-full h-full" src={PROGRAM_IMG[data.program_code]} />
        </div>
      </Tooltip>
    </div>
  );
};
export default Banks;
